<template>
    <div class="product">
        <div class="title">
            <el-breadcrumb >
            <el-breadcrumb-item :to="{ path: '/home/monitor' }">{{type=='product'?'产品检测':type=='sku'?'sku检测':'店铺授权'}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{testname}}{{type=='product'?'检测方案':type=='sku'?'检测方案':'店铺'}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-card>
                <div class="subtitle">
                    <h4>{{testname}}检测方案</h4>
                </div>
                <div class="form">
                    <el-form inline>
                        <el-form-item label="关键字：">
                            <el-input v-model="keyword" class="w400" placeholder="请输入关键字" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="reset">重 置</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getList">查 询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table">
                    <el-table :data="tableData" v-loading="load" style="width: 100%" border>
                        <el-table-column align="center" prop="id" label="ID" width="60"> </el-table-column>
                        <el-table-column align="center" prop="name" label="检测方案名称" show-overflow-tooltip=""> </el-table-column>
                        <el-table-column align="center" prop="sku_total" sortable label="全部SKU数"> </el-table-column>
                        <el-table-column align="center" prop="update_time" label="更新时间"> </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="{ row }">
                                <div class="link">
                                    <el-link type="primary" @click="Detail(row.id)">详情</el-link>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageSize">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="size"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            keyword: "",
            tableData: [],
            total: 0,
            page: 1,
            size: 10,
            type:'',
            testname: sessionStorage.getItem('testname')
        };
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    created() {
      this.type = this.$route.params.type;
        this.getList(1);
    },
    methods: {
        ...mapActions({
            consoleplanDetailList: "detect/consoleplanDetailList",
        }),
        reset() {
            this.keyword = "";
            this.getList();
        },
        getList() {
            this.load = true;
            let params = {
                token: this.getToken,
                name: this.keyword, //方案名称 非必填
                plan_id: this.$route.params.id, //方案id  必填
                page: this.page, //当前页数
                size: this.size, //每页显示条数
            };
            this.consoleplanDetailList(params).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.tableData = data.data.list;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        Detail(id) {
          console.log(this.$route.params.type,'this.$route.params.type5')

            this.$router.push({
                path: `/home/productMonitorDetail/${this.$route.params.type}/${this.$route.params.id}/${id}`,
            }); 
        },
        handleSizeChange(val) {
            this.size = val;
        },
        handleCurrentChange(val) {
            this.page = val;
        },
    },
};
</script>

<style lang="scss" scoped>
.product {
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 20px;
        color: #000000;
        width: 100%;
        padding: 15px 32px;
    }
    ::v-deep .el-table--border th.el-table__cell {
        background-color: #f8f9fe;
    }
    .main {
        min-width: 1200px;
        margin: 20px;
        .el-card {
            height: 760px;
        }
        .subtitle {
            margin-bottom: 35px;
            display: flex;
            align-items: center;
            h4 {
                padding-left: 20px;
                line-height: 18px;
                position: relative;
                font-size: 16px;
                font-weight: bold;
                color: #333333;
                &::before {
                    content: "";
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 2px;
                    background: #2448ff;
                }
            }
        }
    }
    .pageSize {
        text-align: right;
        margin-top: 20px;
    }
    .w400 {
        width: 300px;
    }
    .link {
        a {
            margin: 0 8px;
        }
    }
}
::v-deep .el-card__body {
    padding: 40px;
}
</style>